(() => {
  'use strict';

  if (window.__magneoCustomUploadGateInstalled) return;
  window.__magneoCustomUploadGateInstalled = true;

  const CUSTOM_VARIANT_ID = '49045152301312';
  const DEFAULT_VARIANT_ID = '49045152334080';
  const PHOTOS_PER_CUSTOM_BOX = 9;
  const UPLOAD_ROOT_SELECTOR = '#photouploadapp';
  const ADD_BUTTON_SELECTOR = [
    'button[name="add"]',
    '[id^="ProductSubmitButton-"]',
    '[data-add-to-cart]',
    '.product-form__submit',
    '.sticky-atc-button'
  ].join(',');

  const styleId = 'magneo-custom-upload-gate-style';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .magneo-upload-gate-message {
        display: none;
        margin: 10px 0 0;
        padding: 11px 13px;
        border: 1px solid #dd542b;
        border-radius: 8px;
        background: #fff4ed;
        color: #a82e13;
        font-size: 13px;
        font-weight: 750;
        line-height: 1.4;
      }
      .magneo-upload-gate-message.is-visible { display: block; }
      .magneo-upload-gate-message a {
        color: inherit;
        font-weight: 900;
        text-decoration: underline;
        text-underline-offset: 2px;
      }
      .magneo-upload-gate-status {
        margin: 8px 0 0;
        color: #a82e13;
        font-size: 12px;
        font-weight: 700;
        line-height: 1.35;
      }
      .magneo-upload-gate-status.is-complete { color: #19733a; }
      .magneo-upload-box-guide {
        margin: 8px 0 0;
        padding: 9px 11px;
        border: 1px solid #e8d7c7;
        border-radius: 8px;
        background: #fffaf5;
        color: #54483f;
        font-size: 12px;
        font-weight: 700;
        line-height: 1.45;
      }
      .magneo-upload-box-guide strong { color: #d8562a; }
    `;
    document.head.appendChild(style);
  }

  function getActiveCard() {
    const checked = document.querySelector('.quantity-breaks-container input[name="quantity"]:checked');
    if (!checked) return null;
    if (checked.nextElementSibling?.matches('.quantity-break')) return checked.nextElementSibling;
    const id = checked.id && CSS.escape(checked.id);
    return id ? document.querySelector(`label.quantity-break[for="${id}"]`) : null;
  }

  function applyDefaultVariant() {
    if (window.__magneoDefaultVariantApplied) return true;
    if (new URLSearchParams(window.location.search).has('variant')) return true;

    const container = document.querySelector('.quantity-breaks-container');
    const selects = [...document.querySelectorAll('.quantity-break__variant-select')];
    if (!container || !selects.length) return false;
    if (!selects.some(select => select.querySelector(`option[value="${DEFAULT_VARIANT_ID}"]`))) return true;

    selects.forEach(select => {
      const defaultOption = select.querySelector(`option[value="${DEFAULT_VARIANT_ID}"]`);
      if (!defaultOption || defaultOption.disabled) return;
      select.value = DEFAULT_VARIANT_ID;
      [...select.options].forEach(option => {
        option.selected = option.value === DEFAULT_VARIANT_ID;
        option.toggleAttribute('selected', option.value === DEFAULT_VARIANT_ID);
      });
    });

    const activeCard = getActiveCard();
    const activeSelects = activeCard ? [...activeCard.querySelectorAll('.quantity-break__variant-select')] : [];
    const productForm = document.querySelector('product-form');
    const formIdInput = productForm?.querySelector('input[name="id"]');
    if (formIdInput) {
      formIdInput.value = DEFAULT_VARIANT_ID;
      formIdInput.dataset.selectedId = DEFAULT_VARIANT_ID;
    }

    activeSelects.forEach((select, index) => {
      if (typeof window.quantityBreakVariantChange === 'function') {
        window.quantityBreakVariantChange(
          { target: select },
          activeSelects.length,
          index + 1
        );
      }
    });

    if (activeSelects[0]) {
      activeSelects[0].dispatchEvent(new Event('change', { bubbles: true }));
    }

    window.__magneoDefaultVariantApplied = true;
    return true;
  }

  function scheduleDefaultVariant(attempt = 0) {
    if (applyDefaultVariant() || attempt >= 20) return;
    window.setTimeout(() => scheduleDefaultVariant(attempt + 1), 100);
  }

  function getCustomCount() {
    const activeCard = getActiveCard();
    if (!activeCard) return 0;
    return [...activeCard.querySelectorAll('.quantity-break__variant-select')]
      .filter(select => String(select.value) === CUSTOM_VARIANT_ID).length;
  }

  function requiredPhotoCount() {
    return getCustomCount() * PHOTOS_PER_CUSTOM_BOX;
  }

  function extractUrls(value) {
    if (!value || typeof value !== 'string') return [];
    const urls = value.match(/https?:\/\/[^\s,"'<>]+/gi) || [];
    return urls.filter(url => /uploadcare|ucarecdn|cdn\.shopify|cdn\.shopifycdn|upload/i.test(url));
  }

  function countUploadedProperties(root) {
    const values = new Set();
    const candidates = new Set();
    root?.querySelectorAll('input, textarea').forEach(input => candidates.add(input));
    document.querySelectorAll('form[action*="/cart/add"] input[name^="properties["], form[action*="/cart/add"] textarea[name^="properties["]').forEach(input => candidates.add(input));

    candidates.forEach(input => {
      const value = String(input.value || '').trim();
      if (!value) return;
      const name = String(input.name || '');
      const looksLikeUpload = /upload|photo|file|image/i.test(name) || /uploadcare|ucarecdn/i.test(value);
      if (!looksLikeUpload) return;
      const urls = extractUrls(value);
      if (urls.length) urls.forEach(url => values.add(url));
      else if (/upload|photo|file|image/i.test(name)) values.add(`${name}:${value}`);
    });

    return values.size;
  }

  function countCompletedUploadlyCards(root) {
    if (!root) return 0;
    const loadedWidgets = root.querySelectorAll('.uploadcare--widget_status_loaded').length;
    const completeLabels = (root.innerText.match(/upload complete/gi) || []).length;
    return Math.max(loadedWidgets, completeLabels);
  }

  function getUploadState() {
    const root = document.querySelector(UPLOAD_ROOT_SELECTOR);
    const completed = Math.max(
      countUploadedProperties(root),
      countCompletedUploadlyCards(root)
    );
    const pending = Boolean(root?.querySelector(
      '.uploadcare--widget_status_started, .uploadcare--widget_status_uploading, [aria-busy="true"]'
    )) || /uploading|processing/i.test(root?.innerText || '');
    const failed = Boolean(root?.querySelector('.uploadcare--widget_status_error')) ||
      /upload failed|failed to upload/i.test(root?.innerText || '');
    return { root, completed, pending, failed };
  }

  function getProductForm(source) {
    return source?.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
  }

  function getMessageElement(form) {
    let message = document.querySelector('.magneo-upload-gate-message');
    if (message) return message;
    message = document.createElement('div');
    message.className = 'magneo-upload-gate-message';
    message.setAttribute('role', 'alert');
    message.setAttribute('aria-live', 'assertive');
    const button = form?.querySelector(ADD_BUTTON_SELECTOR) || document.querySelector(ADD_BUTTON_SELECTOR);
    (button?.parentElement || form || document.body).appendChild(message);
    return message;
  }

  function focusUpload() {
    const target = document.getElementById('magneo-upload-trigger') || document.querySelector(UPLOAD_ROOT_SELECTOR);
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(() => {
      target.querySelector('.uploadcare--widget__button_type_open, button, [role="button"]')?.focus({ preventScroll: true });
    }, 450);
  }

  function showBlockedMessage(form, required, state) {
    const missing = Math.max(0, required - state.completed);
    const extra = Math.max(0, state.completed - required);
    const message = getMessageElement(form);
    let reason = `Please upload ${missing} more photo${missing === 1 ? '' : 's'}.`;
    if (extra) reason = `Please remove ${extra} extra photo${extra === 1 ? '' : 's'}.`;
    if (state.pending) reason = 'Please wait until all photos finish uploading.';
    if (state.failed) reason = 'One or more photos failed to upload. Please remove the failed file and try again.';
    message.innerHTML = `Custom style requires ${required} photos (${PHOTOS_PER_CUSTOM_BOX} per Custom Box). ${reason} <a href="#magneo-upload-trigger">Upload 9 Photos for Your Covers</a>`;
    message.classList.add('is-visible');
    focusUpload();
  }

  function hideBlockedMessage() {
    document.querySelector('.magneo-upload-gate-message')?.classList.remove('is-visible');
  }

  function validate(source) {
    const required = requiredPhotoCount();
    if (!required) {
      hideBlockedMessage();
      return true;
    }
    const state = getUploadState();
    if (state.completed === required && !state.pending && !state.failed) {
      hideBlockedMessage();
      return true;
    }
    showBlockedMessage(getProductForm(source), required, state);
    return false;
  }

  function updateStatus() {
    const required = requiredPhotoCount();
    let status = document.querySelector('.magneo-upload-gate-status');
    if (!required) {
      status?.remove();
      document.querySelector('.magneo-upload-box-guide')?.remove();
      hideBlockedMessage();
      return;
    }
    const state = getUploadState();
    const root = state.root;
    if (!root) return;
    if (!status) {
      status = document.createElement('p');
      status.className = 'magneo-upload-gate-status';
      root.insertAdjacentElement('afterend', status);
    }
    let guide = document.querySelector('.magneo-upload-box-guide');
    if (!guide) {
      guide = document.createElement('div');
      guide.className = 'magneo-upload-box-guide';
      status.insertAdjacentElement('afterend', guide);
    }
    const customBoxes = Math.max(1, required / PHOTOS_PER_CUSTOM_BOX);
    const box1Count = Math.min(state.completed, PHOTOS_PER_CUSTOM_BOX);
    const box2Count = Math.min(Math.max(state.completed - PHOTOS_PER_CUSTOM_BOX, 0), PHOTOS_PER_CUSTOM_BOX);
    const complete = state.completed === required && !state.pending && !state.failed;
    status.classList.toggle('is-complete', complete);
    status.textContent = complete
      ? `Photo requirement complete — ${required} of ${required} uploaded.`
      : state.completed > required
        ? `Too many photos — ${state.completed} uploaded, exactly ${required} required.`
        : `Photo upload required for Custom — ${state.completed} of ${required} uploaded.`;
    guide.innerHTML = customBoxes === 2
      ? `<strong>Box 1:</strong> photos 1–9 (${box1Count}/9) &nbsp;·&nbsp; <strong>Box 2:</strong> photos 10–18 (${box2Count}/9)`
      : `<strong>Box 1:</strong> photos 1–9 (${box1Count}/9)`;
  }

  document.addEventListener('click', event => {
    const button = event.target.closest(ADD_BUTTON_SELECTOR);
    if (!button || button.disabled) return;
    if (validate(button)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('submit', event => {
    if (!event.target.matches('form[action*="/cart/add"]')) return;
    if (validate(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  let updateTimer = 0;
  function scheduleUpdate() {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(updateStatus, 80);
  }

  document.addEventListener('change', event => {
    if (event.target.matches('.quantity-breaks-container input[name="quantity"], .quantity-breaks-container .quantity-break__variant-select')) {
      scheduleUpdate();
    }
  });
  document.addEventListener('uploadcare-widget-ready', scheduleUpdate);
  document.addEventListener('uploadcare-upload-complete', scheduleUpdate);
  document.addEventListener('shopify:section:load', scheduleUpdate);

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'value'] });
  scheduleDefaultVariant();
  scheduleUpdate();
})();
